module.exports = __webpack_public_path__ + "img/what_matters_to_us.b2951b42.jpg";